import React from 'react';
import FlashIcon from '../../atoms/icons/flash';
import ListHeaderTitle from '../../atoms/list-header-title';

const TopNewsTitle = props => (
  <ListHeaderTitle {...props}>
    <FlashIcon color="sixth-color" />
  </ListHeaderTitle>
);

export default TopNewsTitle;
